import { allStores } from './constants/allStores';
import { resetStore } from './resetStore';

/**
 * Resets the state of all registered stores.
 *
 * Iterates through the global `allStores` array and calls `resetStore` on each one.
 * This is useful for scenarios like signing out a user or resetting app state
 * between tests.
 *
 * Only stores that were created without `ignoreReset: true` will have the `.reset()` method applied.
 */
export const resetAllStores = (): void => {
  allStores.forEach((store): void => {
    resetStore(store);
  });
};
